import { render, staticRenderFns } from "./CreateEditItemVuetify.vue?vue&type=template&id=ef376a08&scoped=true"
import script from "./CreateEditItemVuetify.vue?vue&type=script&lang=js"
export * from "./CreateEditItemVuetify.vue?vue&type=script&lang=js"
import style0 from "./CreateEditItemVuetify.vue?vue&type=style&index=0&id=ef376a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef376a08",
  null
  
)

export default component.exports